module.exports = __webpack_public_path__ + "img/violet_040.563a2d81.png";